import Button from "@material-ui/core/Button";

import scrollTo from "../../utils/scrollTo";

function ButtonScrollTo(props) {
  const { children, scrollid } = props;

  return (
    <Button {...props} onClick={()=>scrollTo(scrollid)}>
      { children }
    </Button>
  )
}

export default ButtonScrollTo;
